export default function getURLSearchParams(next?: string | null) {
  return next ? Object.fromEntries(new URL(next).searchParams.entries()) : {};
}
